import { render, staticRenderFns } from "./TrafficLightIcon.vue?vue&type=template&id=1f149476&"
import script from "./TrafficLightIcon.vue?vue&type=script&lang=js&"
export * from "./TrafficLightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrafficLightIcon.vue"
export default component.exports